<div class="bg" >
    <div class="wrapper">
   
    <div class="headline">
        <h1>Reset Password OTP</h1>
    </div>
<!-- FORM GROUP -->
<form class="body" [formGroup]="form_group" (ngSubmit)="verifyOTP()">
    <!-- EMAIL INPUT -->
    <h2 style="color:white">Enter OTP Code</h2>
    <p style="color:white;">
      Please enter the 5 digit code that was sent to your email now. Code
      expires in <span class="otp-time">10:00</span>
    </p>
    <div class="otp-group">
      <input
        class="otp-input"
        maxlength="1"
        formControlName="otp1"
        [ngClass]="{ 'is-invalid': submitted && f.otp1.errors }"
      />
      <input
        class="otp-input"
        maxlength="1"
        formControlName="otp2"
        [ngClass]="{ 'is-invalid': submitted && f.otp2.errors }"
      />
      <input
        class="otp-input"
        maxlength="1"
        formControlName="otp3"
        [ngClass]="{ 'is-invalid': submitted && f.otp3.errors }"
      />
      <input
        class="otp-input"
        maxlength="1"
        formControlName="otp4"
        [ngClass]="{ 'is-invalid': submitted && f.otp4.errors }"
      />
      <input
        class="otp-input"
        maxlength="1"
        formControlName="otp5"
        [ngClass]="{ 'is-invalid': submitted && f.otp5.errors }"
      />
      <input
      class="otp-input"
      maxlength="1"
      formControlName="otp6"
      [ngClass]="{ 'is-invalid': submitted && f.otp6.errors }"
    />
    </div>
    <!-- EMAIL INPUT -->

    <!-- BUTTONS -->
    <div style="display: flex;gap: 1rem;">
        <button style=" width: 55%;
        margin: 15px 18% 35px;
        font-size: 14px;
        line-height: 22px;
        font-weight: 700;
        padding: 12px 29px;
        height: 48px;
        text-transform: uppercase;
        color: #ffffff;
        background-color: #00adef;
        border-radius: 16px;
        box-sizing: border-box;
        cursor: pointer;
        text-align: center;" >Verify OTP</button>

    </div>
    <p class="have_account" [ngClass]="['have_account', disabled]" style="color: white;">
      Didn’t get code ?
      <a
        style="color:#00adef; text-decoration: underline; cursor: pointer"
        (click)="resendOTP()"
        >Resend OTP</a
      >
    </p>
    <!-- BUTTONS -->
  </form>
    


    </div>
</div>
